import {
	InputLabel as InputLabelMui,
} from '@mui/material';
import { ChildrenProps, appendClassName } from '@componentLibraryWrapper/common';
import './inputLabel.scss';

export interface InputLabelProps extends ChildrenProps<HTMLLabelElement> {
}

const InputLabel = ({
	className,
	...rest
}: InputLabelProps) => {
	return (
		<InputLabelMui
			{...rest}
			className={appendClassName('sm-inputlabel', className)}/>
	)
}

export default InputLabel;